'use client'

import { useNavigate } from 'react-router-dom'
import { PresetSelectorPage } from '@/components/presets'
import type { PresetApplicationResult } from '@/lib/api/services/industryPresets'

/**
 * Presets - Dashboard page for browsing and applying industry presets
 *
 * This page allows users to:
 * - Browse all available industry presets
 * - Filter by industry and complexity
 * - Preview preset contents before applying
 * - Apply presets to configure their workspace
 */
export default function Presets() {
  const navigate = useNavigate()

  function handlePresetApplied(result: PresetApplicationResult) {
    // Navigate to the dashboard after successful preset application
    // The user can explore their newly configured workspace
    if (result.success) {
      // Optional: Show a toast notification
      console.log('Preset applied successfully:', result.presetName)

      // Navigate to AI Agents page to see the new agents
      if (result.createdAgents.length > 0) {
        navigate('/dashboard/ai')
      } else if (result.createdTemplates.length > 0) {
        navigate('/dashboard/templates')
      } else {
        navigate('/dashboard')
      }
    }
  }

  return (
    <div className="container mx-auto py-6 px-4 max-w-7xl">
      <PresetSelectorPage
        onPresetApplied={handlePresetApplied}
        showHeader={true}
      />
    </div>
  )
}
